//Angular imports
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

//Models
import * as footerOptionsModel from '../../models/footer.options.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() backGroundColor: string = '#fff';
  @Input() fontColor: string = '#bfbfbf';

  footerOptions: Array<footerOptionsModel.FooterOption> = [
    {
      name: '© 2023 Veracio',
      routerLink: 'https://www.veracio.com/'
    },
    {
      name: 'Terms of Use',
      routerLink: 'https://www.boartlongyear.com/company/legal/#terms-of-use'
    },
    {
      name: 'Privacy Policy',
      routerLink: 'https://www.boartlongyear.com/company/legal/#privacy-policy'
    },
    {
      name: 'Privacy Shield',
      routerLink: 'https://www.boartlongyear.com/privacy-shield/'
    },
    {
      name: 'Cookie Policy',
      routerLink: 'https://www.boartlongyear.com/company/cookie-policy/'
    }
  ];

  constructor() {}
}
